<template>
  <v-menu
    bottom
    offsetY
  >
    <template v-slot:activator="{on}">
      <v-tab
        :style="`text-transform: capitalize; color: ${color};`"
        v-on="on"
      >
        {{ lang }}
      </v-tab>
    </template>
    <v-list>
      <v-list-item
        v-for="(lang,idx) in switchLangTo"
        :key="idx"
        @click="onClickChangeLang(lang)"
      >
        {{ lang | uppercase }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        color: {
            type: String,
            default: '#2A3E53',
        },
    },
    data() {
        return {
            langs: ['en', 'fr'],
        };
    },
    computed: {
        ...mapGetters(['lang']),
        switchLangTo() {
            const cLang = this.$i18n.locale; // set the language
            return this.langs.filter(lang => lang !== cLang); // display all languages except the one selected
        },
    },
    methods: {
        ...mapActions({
            setLang: 'setLang',
        }),
        onClickChangeLang(lang) {
            this.setLang(lang);
        },
    },
};
</script>

<style lang="scss" scoped>
    .v-tab {
      padding: 5px;
      min-width: 52px;
    }
</style>
